import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { AppModeService } from 'src/app/angular-wallet-base/services/app-mode.service';
import { getSideMenuStatus } from 'src/app/angular-wallet-base/store/appSettings';
import { AppState } from 'src/app/angular-wallet-base/store/appState';
import { SelectAssetModal } from '../../select-asset-modal/select-asset-modal.component';

@Component({
  selector: 'app-swap-warning-modal',
  templateUrl: './swap-warning.modal.html',
  styleUrls: ['./swap-warning.modal.scss']
})
export class SwapWarningModalComponent implements OnInit {

  public isDesktopMode;

  constructor(
    private modalController: ModalController,
    public appMode: AppModeService,
    protected store: Store<AppState>,
  ) {
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
  }

  ngOnInit() {
  }

  closeModal(allowTx?: string) {
    this.modalController.dismiss(allowTx);
  }

}
